import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { publicHelpAssetUrl } from '../data/loginHelpVideos';
import './DashboardHelpVideoModal.css';

const VIDEO_SRC = publicHelpAssetUrl('/help-videos/sites-dashboard.mp4');

export default function DashboardHelpVideoModal({ open, onClose, title = 'How to use the Site Dashboard' }) {
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (open) setLoadError(false);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose?.();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="dash-help-video-overlay" onClick={onClose} role="presentation">
      <div
        className="dash-help-video-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="dash-help-video-title"
      >
        <div className="dash-help-video-header">
          <h2 id="dash-help-video-title" className="dash-help-video-title">
            {title}
          </h2>
          <button type="button" className="dash-help-video-close" onClick={onClose} aria-label="Close">
            <X size={20} strokeWidth={2} />
          </button>
        </div>
        <div className="dash-help-video-body">
          {loadError && (
            <p className="dash-help-video-error" role="alert">
              Video could not load. Add <code>sites-dashboard.mp4</code> under <code>client/public/help-videos/</code>, run{' '}
              <code>npm run build</code>, and redeploy. Open <code>{VIDEO_SRC}</code> in a new tab to verify the file is served.
            </p>
          )}
          <div className="dash-help-video-frame">
            <video
              key={VIDEO_SRC}
              className="dash-help-video-el"
              controls
              playsInline
              preload="metadata"
              src={VIDEO_SRC}
              onError={() => setLoadError(true)}
              onLoadedData={() => setLoadError(false)}
            >
              Your browser does not support embedded video.
            </video>
          </div>
          <p className="dash-help-video-hint">Nothing plays until you press play.</p>
        </div>
      </div>
    </div>
  );
}
